import React from "react";
import DatePicker from "react-datepicker";
import { Field, ErrorMessage } from "formik";
import { addYears } from "date-fns";
import moment from "moment";

// The late entries end day sits between the close and the event day (blank =
// the event day; MC2 5a45d7e3). Same rule as the backend's
// lateEntryCloseDateError and the website's wizard.
const dayOnly = (d) => (d ? moment(d).format("YYYY-MM-DD") : "");
export const lateEntriesEndError = (values, type) => {
  const late = dayOnly(values.lateEntryCloseDate);
  if (!late) return "";
  const close = dayOnly(values.closing_date);
  const eventDay = dayOnly(type === "feis" ? values.feis_date : values.exam_date);
  if (close && late < close) return "Late entries can't end before registration closes.";
  if (eventDay && late > eventDay) return `Late entries can't end after the ${type === "feis" ? "feis" : "exam"} day.`;
  return "";
};

const EventDate = ({ formik, props }) => {
  const maxDate = addYears(new Date(), 100);
  const dateType = props.type === "feis" ? "feis_date" : "exam_date";
  const dateLabel = props.type === "feis" ? "Feis Date" : "Exam Date";

  return (
    <div className="Eventdate">
      <h4 className="eventPage mt-5">Event date</h4>
      <div className="d-flex flex-column ">
        <div
          className={
            formik.errors.opening_date && formik.touched.opening_date
              ? ""
              : "input-control"
          }
        >
          <label
            className={
              formik.errors.opening_date && formik.touched.opening_date
                ? "label-head-org-error"
                : "label-head-org"
            }
          >
            Reg. Open Date:
          </label>
          <br />
          <Field name="opening_date">
            {({ field, form }) => (
              <DatePicker
                className={
                  form.errors.opening_date && form.touched.opening_date
                    ? "input-box-org-date-error"
                    : "input-box-org-date"
                }
                selected={field.value}
                onChange={(date) => {
                  form.setFieldValue("opening_date", date || "");
                  if (form.values.feis_date) {
                    formik.setFieldTouched(dateType, true);
                    formik.validateField(dateType);
                  }
                  if (form.values.closing_date) {
                    formik.setFieldTouched("closing_date", true);
                    formik.validateField("closing_date");
                  }
                  setTimeout(() => {
                    formik.validateForm();
                  }, 0);
                }}
                onBlur={() => {
                  formik.setFieldTouched("opening_date", true);
                  setTimeout(() => {
                    formik.validateForm();
                  }, 0);
                }}
                minDate={new Date()}
                maxDate={maxDate}
                placeholderText="MM/DD/YYYY"
              />
            )}
          </Field>
          <ErrorMessage
            className="auth-error"
            name="opening_date"
            component="div"
          />
        </div>
        <div
          className={
            formik.errors.closing_date && formik.touched.closing_date
              ? ""
              : "input-control"
          }
        >
          <label
            className={
              formik.touched.closing_date && formik.errors.closing_date
                ? "label-head-org-error"
                : "label-head-org"
            }
          >
            Reg. Close Date:
          </label>
          <br />
          <Field name="closing_date">
            {({ field, form }) => (
              <DatePicker
                className={
                  formik.errors.closing_date && formik.touched.closing_date
                    ? "input-box-org-date-error"
                    : "input-box-org-date"
                }
                selected={field.value}
                onChange={(date) => {
                  form.setFieldValue("closing_date", date || "");
                  form.setFieldTouched("closing_date");
                  if (form.values[dateType]) {
                    formik.setFieldTouched(dateType, true);
                    formik.validateField(dateType);
                  }
                  setTimeout(() => {
                    formik.validateForm();
                  }, 0);
                }}
                onBlur={() => {
                  formik.setFieldTouched("closing_date", true);
                  setTimeout(() => {
                    formik.validateForm();
                  }, 0);
                }}
                placeholderText="MM/DD/YYYY"
                minDate={new Date()}
                maxDate={maxDate}
              />
            )}
          </Field>
          <ErrorMessage
            className="auth-error"
            name="closing_date"
            component="div"
          />
        </div>
        <div className={lateEntriesEndError(formik.values, props.type) ? "" : "input-control"}>
          <label className={lateEntriesEndError(formik.values, props.type) ? "label-head-org-error" : "label-head-org"}>
            Late Entries End:
          </label>
          <br />
          <Field name="lateEntryCloseDate">
            {({ field, form }) => (
              <DatePicker
                className={lateEntriesEndError(form.values, props.type) ? "input-box-org-date-error" : "input-box-org-date"}
                selected={field.value}
                onChange={(date) => {
                  form.setFieldValue("lateEntryCloseDate", date || "");
                  form.setFieldTouched("lateEntryCloseDate");
                }}
                onBlur={() => formik.setFieldTouched("lateEntryCloseDate", true)}
                placeholderText={props.type === "feis" ? "Feis day" : "Exam day"}
                minDate={formik.values.closing_date || null}
                maxDate={formik.values[dateType] || maxDate}
                isClearable
              />
            )}
          </Field>
          {lateEntriesEndError(formik.values, props.type) ? (
            <div className="auth-error">{lateEntriesEndError(formik.values, props.type)}</div>
          ) : (
            <div style={{ maxWidth: 320, marginTop: 4, fontSize: 12, lineHeight: 1.4, color: "#656565" }}>
              After registration closes, late entries (with the late fee) are taken until this day. Blank = the {props.type === "feis" ? "feis" : "exam"} day. The close date = no late entries.
            </div>
          )}
        </div>
        <div
          className={
            formik.errors[dateType] && formik.touched[dateType]
              ? ""
              : "input-control"
          }
        >
          <label
            className={
              formik.errors[dateType] && formik.touched[dateType]
                ? "label-head-org-error"
                : "label-head-org"
            }
          >
            {dateLabel}
          </label>
          <br />
          <Field name={dateType}>
            {({ field, form }) => (
              <DatePicker
                className={
                  form.errors[dateType] && form.touched[dateType]
                    ? "input-box-org-date-error"
                    : "input-box-org-date"
                }
                selected={field.value}
                onChange={(date) => {
                  formik.setFieldTouched(dateType, true);
                  form.setFieldValue(dateType, date || "");
                  formik.validateField(dateType);
                  if (form.values.closing_date) {
                    formik.setFieldTouched("closing_date", true);
                    formik.validateField("closing_date");
                  }
                  setTimeout(() => {
                    formik.validateForm();
                  }, 0);
                }}
                onBlur={() => formik.setFieldTouched(dateType, true)}
                minDate={new Date()}
                maxDate={maxDate}
                placeholderText="MM/DD/YYYY"
              />
            )}
          </Field>
          <ErrorMessage
            className="auth-error"
            name={dateType}
            component="div"
          />
        </div>
        <div className="input-control">
          <label className="label-head-org">
            Print Card Visible Date:
          </label>
          <br />
          <Field name="printCardVisibleDate">
            {({ field, form }) => (
              <DatePicker
                className="input-box-org-date"
                selected={field.value}
                onChange={(date) => {
                  form.setFieldValue('printCardVisibleDate', date || '');
                }}
                onBlur={() => {
                  formik.setFieldTouched('printCardVisibleDate', true);
                }}
                minDate={new Date()}
                maxDate={maxDate}
                placeholderText="MM/DD/YYYY"
              />
            )}
          </Field>
        </div>
      </div>
    </div>
  );
};

export default EventDate;
